import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CreateDocumentaryResourceBody } from "@shared-kernel/domain/types/documentary-resource";

export const documentaryResourceCreate = createAsyncThunk<string, CreateDocumentaryResourceBody, { extra: Partial<Dependencies> }>(
  "documentaryResource/create",
  async (body: CreateDocumentaryResourceBody, { extra: { adminRepository } }) => {
    return adminRepository!.createDocumentaryResource(body);
  },
);

export const documentaryResourceCreateReset = createAction("documentaryResource/createReset");
